import type { Accent } from '../types/accent'

export interface Bonus {
  number: string
  title: string
  accent: Accent
  intro: string
  /** Come mostrare gli elementi: etichette, sequenza con frecce o citazioni. */
  itemsStyle: 'tags' | 'flow' | 'quotes'
  items: string[]
  outro: string[]
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Quick Session Builder™',
    accent: 'pine',
    intro:
      'Costruisci rapidamente la struttura della seduta partendo da 4 elementi:',
    itemsStyle: 'tags',
    items: ['Obiettivo', 'Numero di giocatori', 'Livello', 'Tempo disponibile'],
    outro: [
      "Schede rapide per passare dall'obiettivo all'allenamento senza ricominciare ogni volta da zero.",
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c2420bda-1b88-4d81-a5c1-ec50b2e459d3.jpg',
    alt: 'Un allenatore di pallamano pianifica la seduta su un tablet a bordo campo.',
  },
  {
    number: '2',
    title: 'Correzioni Express™',
    accent: 'rust',
    intro: 'Una guida rapida costruita secondo:',
    itemsStyle: 'flow',
    items: ['Errore', 'Cosa osservare', 'Cue', 'Correzione'],
    outro: [
      'Per movimento, controllo della palla, passaggio, ricezione, palleggio, tiro e difesa.',
      'Meno tempo per cercare la correzione.',
      'Più chiarezza durante la seduta.',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8ad55758-6cf6-49c2-932c-6ad7bd438cd3.jpg',
    alt: "Un allenatore corregge la posizione del corpo di un giocatore con la palla.",
  },
  {
    number: '3',
    title: 'Gruppi Misti Toolkit™',
    accent: 'navy',
    intro: 'Lo stesso esercizio adattato su tre livelli:',
    itemsStyle: 'tags',
    items: ['Base', 'Sviluppo', 'Performance'],
    outro: [
      'Per gestire più facilmente gruppi con capacità differenti senza dover inventare tre esercizi completamente diversi.',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/34b83c75-1f7d-42ed-8ad8-dce0ae4029cd.jpg',
    alt: 'Campo di pallamano diviso in tre zone con gruppi di livelli diversi.',
  },
  {
    number: '4',
    title: '20 Riscaldamenti Pronti™',
    accent: 'ember',
    intro: '20 protocolli semplici organizzati per obiettivo:',
    itemsStyle: 'tags',
    items: [
      'Movimento',
      'Palla',
      'Passaggio',
      'Coordinazione',
      'Reazione',
      'Tiro',
      'Preparazione al gioco',
    ],
    outro: ['Apri. Scegli. Inizia.'],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ece37b46-f063-4afb-a535-6aa7a15287bd.jpg',
    alt: 'Giocatori di pallamano durante un riscaldamento dinamico con la palla.',
  },
  {
    number: '5',
    title: 'Coaching Cues Pocket Guide™',
    accent: 'olive',
    intro: 'Indicazioni tecniche brevi da utilizzare direttamente sul campo.',
    itemsStyle: 'quotes',
    items: [
      'Testa alta.',
      'Palla vicina.',
      'Passa davanti.',
      'Ricevi già orientato.',
      'Abbassa il baricentro.',
      'Guarda prima di ricevere.',
    ],
    outro: ['Meno spiegazioni lunghe.', 'Più indicazioni chiare.'],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/023caf87-da78-43ca-b0df-3203e5e3edc8.jpg',
    alt: 'Due allenatori di pallamano con una lavagnetta tattica a bordo campo.',
  },
]

/** Riepilogo breve usato nella tabella del valore. */
export const bonusValueRows: { label: string; value: string }[] = [
  { label: 'Bonus 1 — Quick Session Builder™', value: '€19' },
  { label: 'Bonus 2 — Correzioni Express™', value: '€17' },
  { label: 'Bonus 3 — Gruppi Misti Toolkit™', value: '€15' },
  { label: 'Bonus 4 — 20 Riscaldamenti Pronti™', value: '€14' },
  { label: 'Bonus 5 — Coaching Cues Pocket Guide™', value: '€12' },
]
